import { createFileRoute } from "@tanstack/react-router";
import { CoursesGrid } from "@/components/cockpit/CoursesGrid";
import { CockpitPageShell } from "@/components/cockpit/CockpitPageShell";
import { CockpitPageHeader } from "@/components/cockpit/CockpitPageHeader";
import { CockpitSkeletonCards } from "@/components/cockpit/CockpitSkeleton";
import { useCockpitSession } from "@/hooks/use-cockpit-session";

export const Route = createFileRoute("/_cockpit/cockpit/kurse/")({
  head: () => ({
    meta: [
      { title: "Kurse – Cockpit – creategy" },
      { name: "robots", content: "noindex, nofollow" },
      { name: "description", content: "Ihre zugewiesenen Kurse im Cockpit." },
    ],
  }),
  component: CockpitCoursesPage,
});

function CockpitCoursesPage() {
  const session = useCockpitSession();

  return (
    <CockpitPageShell>
      <CockpitPageHeader
        title="Kurse"
        description="Ihre zugewiesenen Kurse. Setzen Sie Ihr Training dort fort, wo Sie zuletzt aufgehört haben."
      />

      {session.loading || !session.userId ? (
        <CockpitSkeletonCards />
      ) : (
        <CoursesGrid userId={session.userId} />
      )}
    </CockpitPageShell>
  );
}
